import React from 'react';
import Modal from 'containers/Modal/Modal';
import { updateUser } from 'actions/users/';
import { clearModal } from 'actions/modals/';
import { USER_PROFILE_MODAL } from 'constants/modal';
import { useDispatch, useSelector } from 'react-redux';
import UserProfile from 'components/Users/UserProfile/UserProfile';

function UserProfileModal() {
  const dispatch = useDispatch();
  const user = useSelector(({ user }) => user);
  const modal = useSelector(({ modal }) => modal);
  const isOpen = modal?.type === USER_PROFILE_MODAL;

  function onModalClose() {
    dispatch(clearModal(USER_PROFILE_MODAL));
  }

  /**
    @param {FormData} payload
   */
  function onSubmit(payload) {
    const { company_id: companyId, id: userId } = user;
    payload.append('id', userId);
    payload.append('company_id', companyId);
    dispatch(updateUser(userId, payload, companyId, false));
  }

  return (
    <Modal
      modalTop={5}
      isOpen={isOpen}
      onClose={onModalClose}
      caption="Your Profile"
    >
      <UserProfile
        user={user}
        onSubmit={onSubmit}
        onModalClose={onModalClose}
      />
    </Modal>
  );
}

export default UserProfileModal;
